import mhacks from './mhacks.png';
import pennApps from './pennApps.png';
import civicHacks from './civicHacks.png';
import codeDay from './codeDay.png';
import spaceApps from './SpaceApps.png';
import wicsAthon from './WIcsathon.png';
import technovation from './technovation.png';
import es6Image from './es6_courseImage.png';
import reactJSImage from './reactJS_courseImage.png';
import reactNativeImage from './reactNative_courseImage.jpeg';

export {mhacks, pennApps, civicHacks, codeDay, spaceApps, wicsAthon, technovation, es6Image, reactJSImage, reactNativeImage}

import github_icon from './github_icon.png';
import linkedin_icon from './linkedin_icon.png';
import twitter_icon from './twitter_icon.png';
import udemy_icon from './udemy_icon.png';
import medium_icon from './medium_icon.png';
import mail_icon from './mail_icon.png';

export { github_icon, linkedin_icon, twitter_icon, udemy_icon, medium_icon, mail_icon };



/** WEBPACK FOOTER **
 ** ./src/img/index.js
 **/